
import { defineComponent } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
// import "bootstrap/scss/bootstrap.scss";
//import "@progress/kendo-theme-bootstrap";
//import '@progress/kendo-theme-default/dist/all.css';
// import '@/assets/style/kendo-naive-theme.css';
// import '@/assets/style/kendo-naive-theme.scss';

import { NConfigProvider , GlobalThemeOverrides } from 'naive-ui'
import { colorPickerLight } from 'naive-ui/lib/color-picker/styles';



export default defineComponent({
  name: 'App',
  components: {
  },
  setup()
  {
    const themeOverrides: GlobalThemeOverrides = {
      common: {
        infoColor:'#272F46',
        infoColorPressed:'#353F5E',
        infoColorSuppl:'272F46',
        infoColorHover:'#475580',
        
        primaryColor:'#44AA4D',
        primaryColorPressed:'#0C7A43',
        primaryColorSuppl:'#44AA4D',
        primaryColorHover:'#39B54A',

        
        successColor:'#44AA4D',
        successColorPressed:'#0C7A43',
        successColorSuppl:'#44AA4D',
        successColorHover:'#39B54A',


        warningColor:'#F7931E',
        warningColorHover:'#F7B263',
        warningColorPressed:'#C97310',
        warningColorSuppl:'#F7931E',

        buttonColor2: 'rgba(46, 51, 56, .05)', 
        buttonColor2Hover: 'rgba(46, 51, 56, .09)', 
        buttonColor2Pressed: 'rgba(46, 51, 56, .13)',

        
      },
      DatePicker: {
        itemTextColor:'#0C7A43',
        itemColorActive:'#0C7A43',
        itemColorHover:'rgba(12,122,67,0.2)',
        itemColorIncluded:'rgba(68,170,77,0.2)',
        arrowColor:'#44AA4D',
        iconColor:'#0C7A43',
      },
      Steps:{
        headerTextColorProcess: "#fff",
      }
    }
    
    return {
      themeOverrides
    }
  }
});
